import React from "react";
import {
  Modal,
  Form,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner
} from "reactstrap";

const EasyPaisaEditModal = ({
  editModal,
  editToggle,
  handleUpdateEasyPaisa,
  formData,
  handleInputChange,
  isLoading
}) => {
  return (
    <div>
      <Modal isOpen={editModal} toggle={editToggle}>
        <ModalHeader toggle={editToggle}>Edit Easypaisa Details</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleUpdateEasyPaisa}>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="phoneNo">Full Name</Label>{" "}
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Enter EasyPaisa Name"
                    value={formData?.name}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="phoneNo">Phone No</Label>{" "}
                  <Input
                    type="number"
                    name="phoneNo"
                    id="phoneNo"
                    placeholder="Enter EasyPaisa No"
                    value={formData?.phoneNo}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Col className="p-0">
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>

            <div className="d-flex justify-content-end">
              <Button color="primary" disabled={isLoading} type="submit">
                {" "}
                {isLoading ? <Spinner size="sm" /> : "Update"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default EasyPaisaEditModal;
